import React from "react";
import { metricType } from "../../constants.js";
import ChrLink from "../../../Utils/ChrLink.jsx";
import { getHoverOptions } from "../../../Utils/commonUtils.js";
import { eventTracker, getEventDetails } from "../../../Utils/eventTracker.js";
import { getFormattedNumber } from "./utils.js";


/*
props = {
  children: <string | component>,
  type: <'metric' | 'submetric'>
}
*/

const ChrMetricValue = (props) => {
  const type = props.type || metricType.METRIC;
  let className = (type === metricType.METRIC) ? 'px-1 no-margins font-size-18 py-2 font-600 cui-management-report-temp-metric-value cui-management-report-temp-metric-submetric-link' : 'p-1 font-600 cui-management-report-temp-metric-submetric-link';
  className = `${className} ${!!props.url ? '' : 'cui-management-report-temp-no-link'} ${props.className}`;

  const metricValue = props.children;
  const formattedMetricValue = props.formattedValue;
  const isAString = typeof metricValue === 'string';
  const { valueToDisplay, isANumber } = getFormattedNumber(metricValue);
  const hoverContent = (isANumber || isAString) ? metricValue : "";
  const {eventName, payload} = getEventDetails(props.eventDetails);
  const formattedValueToDisplay = formattedMetricValue || valueToDisplay;
  const clickHandler = () => {
    eventTracker(eventName, payload);
  }

  return (
    <div className={ className }>
      <span { ...getHoverOptions(hoverContent, {'data-boundary': 'clippingParents'}) }>
        <ChrLink href={ props.url } onClick={ clickHandler } isLinkOnClick={ !!props.url } newTab>
          { formattedValueToDisplay }
        </ChrLink>
      </span>
    </div>
  )
}

export default ChrMetricValue;
